module.exports = __webpack_public_path__ + "img/not-found.569c5eab.svg";